<template>
    <div class="step-view">
        <div class="item" :class="{ 'item-check': stepIndex == 1 }">
            <div class="yuan">1</div>
            <div class="txt">条件选择</div>
        </div>
        <div class="line"></div>
        <div class="item" :class="{ 'item-check': stepIndex == 2 }">
            <div class="yuan">2</div>
            <div class="txt">执行动作</div>
        </div>
        <div class="line"></div>
        <div class="item" :class="{ 'item-check': stepIndex == 3 }">
            <div class="yuan">3</div>
            <div class="txt">生效时间</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["stepIndex"],
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.step-view {
    display: flex;
    align-items: center;
    justify-content: center;

    .item {
        width: 0.5rem;
        height: 0.5rem;
        position: relative;

        .yuan {
            margin: 0 auto;
            width: 0.5rem;
            height: 0.5rem;
            background: #e5e5e5;
            border-radius: 50%;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 18px;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .txt {
            position: absolute;
            bottom: -0.325rem;
            left: 50%;
            transform: translateX(-50%);
            width: 1rem;
            text-align: center;
            margin-top: 0.175rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #e5e5e5;
        }
    }

    .item-check {
        .yuan {
            background: #2daea9;
        }

        .txt {
            color: #2daea9;
        }
    }

    .line {
        margin: 0 0.15rem;
        width: 1.7875rem;
        height: 2px;
        background: #e5e5e5;
    }
}
</style>